import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Crm, Custdisposition, disposition, Dnc, Smstemplate } from './model/model.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { AppService } from '../shared/service/AppService.class';
import { Script } from '../message/model/model.class';
import { BehaviorSubject, of } from 'rxjs';
import { Theme } from '../shared/service/AutoTheme';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogRef } from '@angular/material';
import { ScriptEditorComponent } from './script-editor/script-editor.component';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import {uploadImage } from '../../app/app-routing.module'
import {fileMove } from '../../app/app-routing.module'

@Injectable()
export class SettingService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "dnclist";
  }
  // START DISPOSITION DATA

  // public deleteWidget(id): Observable<any> {
  //   this.appmod = 'deleteWidget';
  //   let result = super.deleteService(id);
  //   this.appmod = "dnclist";
  //   return result;
  // }getTable

  public saveCustomizationsValue(data:any): Observable<any> {
       return this.http.post(`${uploadImage}`, data)
  }

  public fileMove(data:any): Observable<any> {
    return this.http.post(`${fileMove}`, data)
}

  detetecustomData(data:any): Observable<any> {
    let temp = this.appmod
    this.appmod = 'custom/detetecustomData';
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public deleteTable(id): Observable<any> {
    this.appmod = 'custom/deleteTable';
    let result = super.saveService(id);
    this.appmod = "disposition";
    return result;
  }

  getTable() {
    this.appmod = "custom/getTable";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }

  getTableField() {
    this.appmod = "custom/getTableField";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }


  public deleteGraph(id): Observable<any> {
    this.appmod = 'custom/deleteGraph';
    let result = super.saveService(id);
    this.appmod = "disposition";
    return result;
  }

  getGraph() {
    this.appmod = "custom/getGraph";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }

  getwidget() {
    this.appmod = "custom/getwidget";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }


  public deleteWidget(id): Observable<any> {
    this.appmod = 'custom/deleteWidget';
    let result = super.saveService(id);
    this.appmod = "disposition";
    return result;
  }

  getModules(){
    this.appmod = "getreporttype";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }
  createtaleFields(data){
    this.appmod = "createreporttable";
    let result = super.saveService(data);
    this.appmod = "disposition";
    return result;
  }

  updatetaleFields(data){
    this.appmod = "updatereporttable";
    let result = super.saveService(data);
    this.appmod = "disposition";
    return result;
  }

  createGraph(data){
    this.appmod = "createreportgraph";
    let result = super.saveService(data);
    this.appmod = "disposition";
    return result;
  }

  gettabulardata(id){
    this.appmod = "gettabluardata";
    let result = super.getService(id);
    this.appmod = "disposition";
    return result;
  }


  public updateGraph(data){
    this.appmod = "updatereportdata";
    let result = super.saveService(data);
    this.appmod = "disposition";
    return result;
  }

  
  getReportSettingFields(type){
    console.log("getDPListAll");
      this.appmod = "custom/getreportsetting";
      let result = super.getService(type);
      this.appmod = "disposition";
      return result;
  }


  reportfields(type) {
    console.log("getDPListAll");
    this.appmod = "custom/reportsetting";
    let result = super.getService(type);
    this.appmod = "disposition";
    return result;
  }

  graphFields(type) {
    this.appmod = "custom/graphSetting";
    let result = super.getService(type);
    this.appmod = "disposition";
    return result;
  }

  public getAgentGroup(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'agentgroup';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
  public getCampaignlist(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'getcampaignlist';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
  public getIvrList(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'ivrlist';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public getDisPositionList(): Observable<any> {
    console.log("getDPListAll");
    this.appmod = "getDPListAll";
    let result = super.getService();
    this.appmod = "disposition";
    return result;
  }

  private apiUrl = 'https://google.com';

  // checkUrl(url: string): Observable<{ status: boolean }> {
  //   console.log("kool",url)
  //   return this.http.post<{ status: boolean }>("checkurl", { url });
  // }
  // checkUrl(url: string): Observable<boolean> {
  //   return this.http.get(url, { observe: 'response' }).pipe(
  //     map(response => response.status === 200),
  //     catchError((error: HttpErrorResponse) => {
  //       console.error(`URL check failed for ${url}`, error);
  //       return of(false);
  //     })
  //   );
  // }
  // checkUrl(data): Observable<any> {
  //   return this.http.post<any>('checkurl', {"data":data}, { headers: {"Content-Type": "application/json"}, params:{type:"main"}});
  // }

  public checkurl(data): Observable<any> {
    console.log("postDisPosition",data);
    this.appmod = "checkurl";
    let result = this.saveService(data);
    this.appmod = "disposition";
    return result;
  }
  getWEBHOOK(): Observable<any> {
    this.appmod = 'getwebhook';
    let result = super.getService();
    this.appmod = 'disposition';
    return result;
  }

  public savewebhook(data): Observable<any> {
    console.log("postDisPosition");
    this.appmod = "savewebhook";
    let result = this.saveService(data);
    this.appmod = "disposition";
    return result;
  }
  public updatewebhook(data: any, id: number): Observable<any> {
    console.log("pooro",data,id)
    this.appmod = 'updatewebhook';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }
  public Deletewebhook(id: any): Observable<any> {
    console.log("data", id);
    this.appmod = "webhookDelete";
    let result = super.deleteService(id);
    this.appmod = "disposition";
    return result;
  }

  public DeleteDPosition(id: any): Observable<any> {
    console.log("data", id);
    this.appmod = "deleteDPosition";
    let result = super.deleteService(id);
    return result;
  }

  public postDisPosition(data): Observable<any> {
    console.log("postDisPosition");
    this.appmod = "postDisPosition";
    let result = this.saveService(data);
    // this.appmod = "disposition";
    return result;
  }

  public editDisPosition(data: any, id: number): Observable<any> {
    this.appmod = 'editDisPosition';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }

  public ChangeColor(data: any, id: number): Observable<any> {
    this.appmod = 'editchangeColor';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }

  public editstatus(data: any, id: number): Observable<any> {
    this.appmod = 'editstatus';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }
  public editScheduleStatus(data: any, id: number): Observable<any> {
    this.appmod = 'editschedulestatus';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }
  public editSaleStatus(data: any, id: number): Observable<any> {
    this.appmod = 'editsale';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }
  public AutomationStatus(data: any, id: number): Observable<any> {
    this.appmod = 'automationStatus';
    let result = super.updateService(data, id);
    this.appmod = 'disposition';
    return result;
  }

  // END DISPOSITION DATA

  public getDncList(): Observable<any> {
    this.appmod = "getDncListAll";
    let result = super.getService("main");
    this.appmod = "dnclist";
    return result;
  }

  //   public getDNCList(id:any):Observable<any>
  //   {
  //     return this.http.get('/assets/jsondata/dnclist_'+id+'.json');
  //   }
  public getaudioList(id: any): Observable<any> {
    return this.http.get('/assets/jsondata/audiolist_' + id + '.json');
  }
  // public getSMSList(id:any):Observable<any>
  // {
  //   return this.http.get('/assets/jsondata/smslist_'+id+'.json');
  // }
  public getCampaign(): Observable<any> {
    return super.getOption("campaign");
  }

  public getDncDetail(path: string, key: number): Observable<any> {
    this.appmod = path;
    let result = super.detailService(key);
    this.appmod = 'dnclist';
    return result;
  }

  public getDNCData(id): Observable<any> {
    this.appmod = "getdncdata";
    let result = super.getService(id);
    this.appmod = 'dnclist';
    return result;
  }

  public DncDelete(key): Observable<any> {
    this.appmod = "dnclist";
    let result = super.deleteService(key);
    return result;
  }
  public DncNumberDelete(key): Observable<any> {
    this.appmod = 'deletedncnumber';
    let result = super.deleteService(key);
    this.appmod = 'dnclist';
    return result;
  }

  public downloadDncList(data: any): Observable<any> {
    this.appmod = 'custom/downloaddnclist';
    let result = super.getDownload(data, 'downloaddnclist');
    this.appmod = 'dnclist';
    return result;
  }

  public downloadDncCampList(data?: any): Observable<any> {
    this.appmod = 'custom/downloaddnccamplist';
    let result = super.getDownload(data, 'downloaddnccamplist');
    this.appmod = 'dnclist';
    return result;
  }

  public InsertDncNumber(data): Observable<any> {
    console.log("Data==>" + JSON.stringify(data));
    this.appmod = 'insertdncnumber';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public InsertDnc(data): Observable<any> {
    console.log("Data==>" + JSON.stringify(data));
    this.appmod = 'dncadd';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  // public inserttylnyx(data): Observable<any> {
  //   console.log("Data==>" + JSON.stringify(data));
  //   this.appmod = 'custom/addtelnyx';
  //   let result = super.saveService(data);
  //   return result;
  // }

  public insertthinq(data): Observable<any> {
    console.log("Data==>" + JSON.stringify(data));
    this.appmod = 'custom/addthinq';
    let result = super.saveService(data);
    return result;
  }

  public GetProviderCredentials(): Observable<any> {
    this.appmod = 'custom/providerauthkey';
    let result = super.getService();
    return result;
  }

  /* ---------------------- new api callation----------------------- */
  public getEmailTemplates(): Observable<any> {
    this.appmod = 'get_email_template';
    let result = super.getService();
    this.appmod = 'emailtemplate';
    return result;
  }

  public addEmailTemplate(data: any): Observable<any> {
    this.appmod = 'save_email_template';
    let result = super.saveService(data);
    this.appmod = 'emailtemplate';
    return result;
  }

  public editEmailTemplate(data: any, id: number): Observable<any> {
    this.appmod = 'update_email_template';
    let result = super.updateService(data, id);
    this.appmod = 'emailtemplate';
    return result;
  }

  public deleteEmailTemplate(id: number): Observable<any> {
    this.appmod = 'delete_email_template';
    let result = super.deleteService(id);
    this.appmod = 'emailtemplate';
    return result;
  }

  public getSmsTemplate(): Observable<any> {
    this.appmod = 'get_sms_template';
    let result = super.getService();
    this.appmod = 'emailtemplate';
    return result;
  }

  public addSmsTemplate(data: any): Observable<any> {
    this.appmod = 'save_sms_template';
    let result = super.saveService(data);
    this.appmod = 'emailtemplate';
    return result;
  }

  public editSMSTemplate(data: any, id: number): Observable<any> {
    this.appmod = 'update_sms_template';
    let result = super.updateService(data, id);
    this.appmod = 'emailtemplate';
    return result;
  }

  public deleteSmsTemplate(id: number): Observable<any> {
    this.appmod = 'delete_sms_template';
    let result = super.deleteService(id);
    this.appmod = 'emailtemplate';
    return result;
  }
  public enableTemp(id: any, num: number): Observable<any> {
    this.appmod = 'ensmstemplate';
    let result = super.updateService(id, num);
    this.appmod = 'emailtemplate';
    return result;
  }
  public enblEMLTemp(id: any, num: number): Observable<any> {
    this.appmod = 'enEMLtemplate';
    let result = super.updateService(id, num);
    this.appmod = 'emailtemplate';
    return result;
  }


  public savedispoGroup(id: number): Observable<any> {
    this.appmod = 'custom/savedispoGroup';
    let result = super.saveService(id);
    this.appmod = 'dnclist';
    return result;
  }

  editSkill(data, id) {
    this.appmod = 'editskill';
    let result = super.updateService(data, id);
    this.appmod = 'dnclist';
    return result;
  }

  deleteSkill(id) {
    this.appmod = 'deleteskill';
    let result = super.deleteService(id);
    this.appmod = 'dnclist';
    return result;
  }

  getSkills() {
    this.appmod = 'skill';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }

  addSkill(data) {
    this.appmod = 'addskill';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  getLanguages() {
    this.appmod = 'language';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }

  addLanguage(data) {
    this.appmod = 'addlanguage';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  editLanguage(data, id) {
    this.appmod = 'editlanguage';
    let result = super.updateService(data, id);
    this.appmod = 'dnclist';
    return result;
  }

  getSkillAgents(id: any) {
    let temp = this.appmod;
    this.appmod = 'skillagentlist';
    let result = super.getService(id);
    this.appmod = temp;
    return result;
  }

  getLanguageAgents(id: any) {
    let temp = this.appmod;
    this.appmod = 'languageagentlist';
    let result = super.getService(id);
    this.appmod = temp;
    return result;
  }

  getLanguageList() {
    this.appmod = 'languagelist';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }

  public getdispoGroup(): Observable<any> {
    this.appmod = 'custom/getdispoGroup';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }
  public updatedispoGroup(data: any, id: number): Observable<any> {
    this.appmod = 'custom/updatedispoGroup';
    let result = super.updateService(data, id);
    this.appmod = 'dnclist';
    return result;
  }

  public deletedispoGroup(id: any): Observable<any> {
    this.appmod = 'custom/deletedispoGroup';
    let result = super.deleteService(id);
    this.appmod = 'dnclist';
    return result;
  }
  public get_Dipso(id): Observable<any> {
    this.appmod = 'custom/get_Dipso';
    let result = super.getService(id);
    this.appmod = 'dnclist';
    return result;
  }
  public assign_Dispo(data: any, type: any): Observable<any> {
    this.appmod = 'custom/assign_dispo';
    let result = super.saveService(data, type);
    this.appmod = 'dnclist';
    return result;
  }
  public delete_Dispo(data: any, type: any): Observable<any> {
    this.appmod = 'custom/delete_Dispo';
    let result = super.saveService(data, type);
    this.appmod = 'dnclist';
    return result;
  }
  public deleteAssign_dispo(id: any, type: any): Observable<any> {
    this.appmod = 'custom/deleteAssign_dispo';
    let result = super.deleteService(id, type);
    this.appmod = 'dnclist';
    return result;
  }
  public get_Groups(id): Observable<any> {
    this.appmod = 'custom/get_Groups';
    let result = super.getService(id);
    this.appmod = 'dnclist';
    return result;
  }
  // public getSelectedTimeZone(data: any): Observable<any> {
  //   this.appmod = 'gettimedata';
  //   let result = super.getService(data);
  //   this.appmod = 'dnclist';
  //   return result;
  // }

  // public savetimedata(data: any): Observable<any> {
  //   console.log(data)
  //   this.appmod = 'savetimedata';
  //   let result = super.saveService(data);
  //   this.appmod = 'dnclist';
  //   return result;
  // }

  public saveapitimedata(data: any): Observable<any> {
    console.log(data)
    this.appmod = 'saveapitimedata';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }
  
  public getservertime(): Observable<any> {
    this.appmod = 'getservertimedata';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }

  // public getTimeZone(data: any): Observable<any> {
  //   this.appmod = 'gettimezonedata';
  //   let result = super.getService(data);
  //   this.appmod = 'dnclist';
  //   return result;
  // }

  public savedid(data: any): Observable<any> {
    this.appmod = 'custom/savedid';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public getdidconfig(id): Observable<any> {
    this.appmod = 'custom/getdidconfig';
    let result = super.getService(id);
    this.appmod = 'dnclist';
    return result;
  }

  public setdefaultDID(data): Observable<any> {
    this.appmod = 'custom/setDID';
    let result = super.updateService(data, 1);
    this.appmod = 'dnclist';
    return result;
  }
  public updatedid(data: any): Observable<any> {
    this.appmod = 'custom/updatedid';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public setdefault(data: any): Observable<any> {
    this.appmod = 'custom/setdefault';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }
  public deletdid(id: any, type): Observable<any> {
    this.appmod = 'custom/deletdid';
    let result = super.deleteService(id, type);
    this.appmod = 'dnclist';
    return result;
  }

  public savedidsms(data: any): Observable<any> {
    this.appmod = 'custom/savedidsms';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public getdidconfigsms(id): Observable<any> {
    this.appmod = 'custom/getdidconfigsms';
    let result = super.getService(id);
    this.appmod = 'dnclist';
    return result;
  }
  public updatedidsms(data: any): Observable<any> {
    this.appmod = 'custom/updatedidsms';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public setdefaultsms(data: any): Observable<any> {
    this.appmod = 'custom/setdefaultsms';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }
  public deletdidsms(id: any, type): Observable<any> {
    this.appmod = 'custom/deletdidsms';
    let result = super.deleteService(id, type);
    this.appmod = 'dnclist';
    return result;
  }
  public savesmtp(data: any): Observable<any> {
    this.appmod = 'custom/savesmtp';
    let result = super.saveService(data);
    this.appmod = 'dnclist';
    return result;
  }

  public enablestatus(data: any): Observable<any> {
    this.appmod = 'custom/enblstatus';
    let result = super.updateService(data, 1);
    this.appmod = 'dnclist';
    return result;
  }
  public smtpdelete(id: any): Observable<any> {
    this.appmod = 'custom/deletesmtp';
    let result = super.deleteService(id)
      ;
    this.appmod = 'dnclist';
    return result;
  }

  public Getsmtp(): Observable<any> {
    this.appmod = 'custom/GetSMTP';
    let result = super.getService();
    this.appmod = 'dnclist';
    return result;
  }
  public saveReport(data:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/addReport';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }
  public getAllReports(data?:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/getallreports';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
  public deleteReport(id?:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/deletcustomreport';
    let result = super.deleteService(id);
    this.appmod = tmp;
    return result;
  }

  public mapReports(data:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/mapreports';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public copyReports(data:any):Observable<any>{
    let tmp = this.appmod;
    this.appmod = 'custom/copyreports';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public updateMapReport(data: any, id): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/updateMapReport';
    let result = super.updateService(data, id);
    this.appmod = tmp;
    return result;
  }

  public getallMainReports(data?:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/getallmapreports';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }

  public deletemapReport(id?:any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/deletemapreport';
    let result = super.deleteService(id);
    this.appmod = tmp;
    return result;
  }

  public getAllCustomer(data?: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/getCustomer';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
  public getSingleCustomer(data?: any): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/getsingleCustomer';
    let result = super.getService(data);
    this.appmod = tmp;
    return result;
  }

  public getReport() {
    let tmp = this.appmod
    this.appmod = 'custom/getNewReport';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
}

@Injectable()
export class SmstemplateService extends AppService<Smstemplate>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "smstemplate";
  }
  public customFields(): Observable<any> {
    this.appmod = 'customfields';
    let result = super.getService("customfields");
    this.appmod = 'smstemplate';
    return result;
  }
  public smstemplate(data: any): Observable<any> {
    console.log("Data##" + data);
    this.appmod = 'smsTemplateData';
    let result = super.saveService(data);
    this.appmod = 'smstemplate';
    return result;
  }

  public smstemplateDelete(Id: any): Observable<any> {
    this.appmod = 'smsTemplateDelete';
    let result = super.deleteService(Id);
    console.log("result" + JSON.stringify(result));
    this.appmod = 'smstemplate';
    return result;
  }

  public editSmsTemplate(data: any, id: any): Observable<any> {
    console.log("data" + JSON.stringify(data));
    console.log("data" + JSON.stringify(id));
    this.appmod = 'smsTemplateEdit';
    let result = super.updateService(data, id);
    console.log("Result===>" + result);
    this.appmod = 'smstemplate';
    return result;
  }

}

@Injectable()
export class MessageService extends AppService<Script>
{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "message";
  }
  // public getCampaign():Observable<Option[]>
  // {
  //   return super.getOption("campaign");
  // }

  public getCampaign(): Observable<any> {
    return super.getOption("campaign");
  }


  public updateName(name, key): Observable<any> {
    this.appmod = 'messagenameupdate';
    // this.appmod='converttts';
    let result = super.updateService({ 'name': name }, key);
    this.appmod = 'message';
    return result;
  }

  addAudioGroup(data){
    this.appmod = 'addaudiogroup';
    // this.appmod='converttts';
    let result = super.saveService(data);
    this.appmod = 'message';
    return result;
  }
  updateAudioGroup(data,id){
    this.appmod = 'updateaudiogroup';
    // this.appmod='converttts';
    let result = super.updateService(data,id);
    this.appmod = 'message';
    return result;
  }
  deleteAudioGroup(id){
    this.appmod = 'deleteaudiogroup';
    // this.appmod='converttts';
    let result = super.deleteService(id);
    this.appmod = 'message';
    return result;
  }
  getAudioGroup(){
    this.appmod = 'getaudiogroup';
    // this.appmod='converttts';
    let result = super.getService();
    this.appmod = 'message';
    return result;
  }
  public getgttstDelete(text): Observable<any> {
    this.appmod = 'msgttsdelete';
    // this.appmod='converttts';
    let result = super.deleteService(text);
    this.appmod = 'message';
    return result;
  }
  /* public getgtts(text):Observable<any>
  {
    this.appmod='pollytts';
    // this.appmod='converttts';
    let result = super.saveService({'text':text});
    this.appmod='message';
    return result;
  } */

  public getgtts(text): Observable<any> {
    this.appmod = 'convertttscloud';
    // this.appmod='converttts';
    let result = super.saveService(text);
    this.appmod = 'recordvoice';
    return result;
  }
  public updateaudio(data: any): Observable<any> {
    this.appmod = 'audioupdate';
    let result = super.updateService(data, 1);
    this.appmod = 'message';
    return result;
  }

  public setedaudio(): Observable<any> {
    this.appmod = 'getsetedAudio';
    let result = super.getService();
    this.appmod = 'message';
    return result;
  }

  public getAudioLanguages(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'language';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }




}

@Injectable()
export class RecordVoiceService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "recordvoice";
  }

  public sendNumberToDial(number): Observable<any> {
    this.appmod = "sendnumbertodial";
    let result = super.saveService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public getDialingStatus(number): Observable<any> {
    this.appmod = "getdialingstatus";
    let result = super.getService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public getRecordedFile(): Observable<any> {
    this.appmod = "getrecordedfile";
    let result = super.getService();
    this.appmod = "recordvoice";
    return result;
  }
  saveTTSMessage(data) {
    this.appmod = "savetts";
    let result = super.saveService(data);
    this.appmod = "recordvoice";
    return result;
  }

  updateTTSMessage(data: { name: string; tts: string; id: number }, audiogrouid: number) {
    this.appmod = "updatetts";
    const payload = { name: data.name, tts: data.tts, audiogrouid };
    let result = super.updateService(payload, data.id);
    this.appmod = "recordvoice";
    return result;
  }
  
  public deleteNumber(number): Observable<any> {
    this.appmod = "deleterecordnumber";
    let result = super.deleteService(number);
    this.appmod = "recordvoice";
    return result;
  }

  public getAudioLanguages(): Observable<any> {
    let tmp = this.appmod;
    this.appmod = 'language';
    let result = super.getService();
    this.appmod = tmp;
    return result;
  }
}

@Injectable()
export class MessageScrService extends AppService<Script>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "ttsscript";
  }
  public listen(data): Observable<any> {
    this.appmod = "listenvoice";
    let result = super.saveService(data);
    this.appmod = "ttsscript";
    return result;
  }

  public getgttsSave(text): Observable<any> {
    this.appmod = 'msgttssave';
    // this.appmod='converttts';
    let result = super.saveService(text);
    this.appmod = 'ttsscript';
    return result;
  }

  public getgttsDelete(text): Observable<any> {
    this.appmod = 'msgttsdelete';
    // this.appmod='converttts';
    let result = super.deleteService(text);
    this.appmod = 'ttsscript';
    return result;
  }

  public getgttsUpdate(text, key): Observable<any> {
    this.appmod = 'msgttsupdate';
    // this.appmod='converttts';
    let result = super.updateService(text, key);
    this.appmod = 'ttsscript';
    return result;
  }



  public customFields(): Observable<any> {
    this.appmod = 'customfields';
    let result = super.getService("customfields");
    this.appmod = 'ttsscript';
    return result;
  }



  public getVoiceList(lang?: string): Observable<any> {
    this.appmod = 'getvoice';
    let result = super.getService("voicelist", lang);
    this.appmod = 'ttsscript';
    return result;

  }

}
//---------------label service-------------------------->
@Injectable()
export class LabelMngService extends AppService<Crm>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "crm";
  }

  Savecrmlabel(data: any, key: any) {
    let temp = this.appmod;
    this.appmod = 'custom/updatecrm';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }

  getcareerbld() {
    let temp = this.appmod;
    this.appmod = 'careerbldr';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }

  public GetCRMdata(id_campaign): Observable<any> {
    this.appmod = "crm";
    let result = super.getService("main", id_campaign);
    return result;
  }


  getCRMLabels() {
    let temp = this.appmod;
    this.appmod = 'get_crm_labels';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }


  deleteCRMLabels(id: number): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "deletecrmlabels";
    let data = this.deleteService(id);
    this.appmod = tmp;
    return data;
  }

  SaveCRMLabel(data: any) {
    let temp = this.appmod;
    this.appmod = 'save_crm_label';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }

  SaveCRMConfig(data: any) {
    let temp = this.appmod;
    this.appmod = 'save_crm_config';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }

  byDefault(data: any) {
    let temp = this.appmod;
    this.appmod = 'custom/byDeafultcrm';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }

}

//---------------customdisposition service--------------------->
@Injectable({
  providedIn: 'root'
})
export class CustDisSettionService extends AppService<Custdisposition>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "customdisposition";
  }

  public savecustomdisposition(data: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/savecustomdispo';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }


  public updateStatus(data: any, key): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/updatestatusdispo';
    let result = this.updateService(data, key);
    this.appmod = temp;
    return result;
  }

  public deleteDis(Id: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/deletecustomdispo';
    let result = super.deleteService(Id, "main");
    this.appmod = temp;
    return result;
  }


  public getWorkflow(type: string, filter: any): Observable<any> {
    return this.getService(type, filter);
  }

  public RefreshCDisposition(): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/refreshcdisposition';
    let result = this.getService();
    this.appmod = temp;
    return result;
  }

  public UpdateDispoKeys(data: any, key: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/dispokeysetting';
    let result = this.updateService(data, key);
    this.appmod = temp;
    return result;


  }

  public UpdateSaleStatus(data: any, key): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'custom/update_sale_status_dispo';
    let result = this.updateService(data, key);
    this.appmod = temp;
    return result;
  }

  public getautomation(id: any) {
    let temp = this.appmod;
    this.appmod = 'get_automation';
    let result = this.getService(id);
    this.appmod = temp;
    return result;
  }

  public mappedAutmation(data: any): Observable<any> {
    this.appmod = 'map_disposition';
    let result = super.saveService(data);
    this.appmod = '';
    return result;
  }

}

// export class ScriptService extends AppService<Custdisposition>{
//   res: any;


//   constructor(protected http: HttpClient, protected dataTheme: Theme, public router: Router, public route: ActivatedRoute) {
//     super(http);
//     this.appmod = "script";
//   }

//   public saveScript(data: any): Observable<any> {
//     this.appmod = 'savescript';
//     let result = super.saveService(data);
//     this.appmod = 'script';
//     return result;
//   }
//   public getScripts(): Observable<any> {
//     this.appmod = 'getscript';
//     let result = super.getService();
//     this.appmod = 'script';
//     return result;
//   }
//   scriptDelete(id): Observable<any> {
//     this.appmod = 'deletescript';
//     let result = super.deleteService(id);
//     this.appmod = 'script';
//     return result;
//   }
//   scriptEdit(id, data): Observable<any> {
//     this.appmod = 'editscript';
//     let result = super.saveService(id, data);
//     this.appmod = 'script';
//     return result;
//   }

//   onSubmit(data, callback = () => { }) {
//     console.log(data, " testing data is coming or not submit :::@@##$$%")
//     this.dataTheme.editorData.subscribe(res => {
//       this.res = res;
//     })
//     console.log(console.log(window.sessionStorage.getItem('scriptData')))
//     if (data.data != 'false') {
//       console.log("coming data here to checking ::: ", this.res.script, this.res.name);

//       this.saveScript({ script: this.res.script, name: this.res.name }).subscribe(res => {
//         console.log(res)
//         let result = res
//         sessionStorage.setItem("last_id_script", result.insertId)
//         //this.openEditor()
//         console.log((this.route.snapshot['_routerState'].url).split('?')[0], (this.route.snapshot['_routerState'].url).split('?')[0] == '/main/setting/script')
//         return callback()
//       })

//     } else {

//       this.scriptEdit({ name: this.res.name, script: this.res.script }, data.data1).subscribe(res => {
//         console.log(res)
//         window.sessionStorage.removeItem('scriptData')
//         window.sessionStorage.removeItem('nameData')
//         // this.router.navigate(['/main/setting/script'])
//         return callback()
//       })
//     }
//   }
// }
export class ScriptService extends AppService<Custdisposition>{
  res: any;
  constructor(protected http: HttpClient, protected dataTheme: Theme, public router: Router, public route: ActivatedRoute) {
    super(http);
    this.appmod = "script";
  }

  public saveScript(data: any): Observable<any> {
    this.appmod = 'savescript';
    let result = super.saveService(data);
    this.appmod = 'script';
    return result;
  }

  uploadaudio(data: any): Observable<any> {
    return this.http.post(environment.SERVER + 'uploascriptdaudio', data)
  }
  
  public getscripteditdata(id:any):Observable<any>{
    this.appmod = 'geteditdata';
    let result = super.getService(id);
    this.appmod = 'script';
    return result;
  }

  public getScripts(): Observable<any> {
    this.appmod = 'getscript';
    let result = super.getService();
    this.appmod = 'script';
    return result;
  }
  scriptDelete(data): Observable<any> {
    this.appmod = 'deletescript';
    let result = super.getService(data);
    this.appmod = 'script';
    return result;
  }

  scriptEdit(data): Observable<any> {
    this.appmod = 'editscript';
    let result = super.saveService(data);
    this.appmod = 'script';
    return result;
  }

  assigndata(data): Observable<any> {
    this.appmod = 'assigndata';
    let result = super.saveService(data);
    this.appmod = 'script';
    return result;
  }


  updatedispo(data): Observable<any> {
    this.appmod = 'updatedispodata';
    let result = super.saveService(data);
    this.appmod = 'script';
    return result;
  }

  setScriptDeafult(data): Observable<any> {
    let tmp = this.appmod
    this.appmod = 'custom/deafultscript';
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  // onSubmit(data, callback = () => { }) {
  //   console.log(data, " testing data is coming or not submit :::@@##$$%")
  //   this.dataTheme.editorData.subscribe(res => {
  //     this.res = res;
  //   })
  //   console.log(console.log(window.sessionStorage.getItem('scriptData')))
  //   if (data.data != 'false') {
  //     console.log("coming data here to checking ::: ", this.res.script, this.res.name);

  //     this.saveScript({ script: this.res.script, name: this.res.name }).subscribe(res => {
  //       console.log(res)
  //       let result = res
  //       sessionStorage.setItem("last_id_script", result.insertId)
  //       //this.openEditor()
  //       console.log((this.route.snapshot['_routerState'].url).split('?')[0], (this.route.snapshot['_routerState'].url).split('?')[0] == '/main/setting/script')
  //       return callback()
  //     })

  //   } else {

  //     this.scriptEdit({ name: this.res.name, script: this.res.script }, data.data1).subscribe(res => {
  //       console.log(res)
  //       window.sessionStorage.removeItem('scriptData')
  //       window.sessionStorage.removeItem('nameData')
  //       // this.router.navigate(['/main/setting/script'])
  //       return callback()
  //     })
  //   }
  // }
}

export class ObjectionService extends AppService<Custdisposition>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "objectionscript";
  }

}


export class ObjectionlistService extends AppService<Custdisposition>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "objectionlistscript";
  }

  assignsubdata(data): Observable<any> {
    this.appmod = 'assignsubdata';
    let result = super.saveService(data);
    this.appmod = 'objectionlistscript';
    return result;
  }

}

@Injectable()
export class IvrServicesetting extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "IVRservice";
  }
  saveIVR(data: any): Observable<any> {
    this.appmod = 'custom/saveIVR';
    let result = super.saveService(data);
    this.appmod = 'IVRservice';
    return result;
  }

  getIVR(): Observable<any> {
    this.appmod = 'custom/getIVR';
    let result = super.getService();
    this.appmod = 'IVRservice';
    return result;
  }
  get_singleIVR(id: any): Observable<any> {
    this.appmod = 'custom/get_singleIVR';
    let result = super.getService(id);
    this.appmod = 'IVRservice';
    return result;
  }
  updateIVR(data: any): Observable<any> {
    this.appmod = 'custom/updateIVR';
    let result = super.saveService(data);
    this.appmod = 'IVRservice';
    return result;
  }
  deleteIVR(data: any): Observable<any> {
    this.appmod = 'custom/deleteIVR';
    let result = super.deleteService(data);
    this.appmod = 'IVRservice';
    return result;
  }
  test_IVR(data: any): Observable<any> {
    this.appmod = 'custom/test_IVR';
    let result = super.saveService(data);
    this.appmod = 'IVRservice';
    return result;
  }

  IVR_tree(data: any): Observable<any> {
    this.appmod = 'custom/IVR_tree';
    let result = super.getService(data);
    this.appmod = 'IVRservice';
    return result;
  }
  addnew_Agent(data: any) {    
    let temp = this.appmod;
    this.appmod = 'custom/saveAgent';
    let result = this.saveService(data);
    this.appmod = temp;
    return result;
  }

  getSkillGroup(agentGroupId: any): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'ivrskillslist';
    let result = super.getService(agentGroupId);
    this.appmod = temp;
    return result;
  }

  getSkills(): Observable<any> {
    let temp = this.appmod;
    this.appmod = 'skill';
    let result = super.getService();
    this.appmod = temp;
    return result;
  }
}

